module.exports = __webpack_public_path__ + "img/usersIcon.9be2156a.png";